module.exports = __webpack_public_path__ + "static/img/m_improvement_2.b6b23c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/m_improvement_2.png
// module id = NxVz
// module chunks = 1